import { IAccountLinkParams, IAccountLinkRemoveParams } from '@aqx-core/common/api/account-link';
import { request } from '@aqx-core/common/request';

export default {
  linkAccount: (params: IAccountLinkParams) => request.post<boolean>('/api/account/link/v1', params),
  removeLinkedAccount: (params: IAccountLinkRemoveParams) =>
    request.delete<boolean>('/api/account/link/v1', { params }),
  verifyPassword: (params: IAccountLinkParams) => request.post<boolean>('/api/account/link/v1/verify', params)
};
